import { z } from "zod";
import { BaseAnalyticsEvent } from "./base";
export const Documentation_Click = BaseAnalyticsEvent.extend({
    name: z.literal("Documentation_Click"),
    properties: z.object({
        url: z.string(),
        view: z.enum([
            "in-product",
            "new-tab"
        ])
    })
});
